import React from 'react';
import { useTranslation } from 'react-i18next';
import Logger from '~/utils/logger/logger';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';

export interface Props {
  langKey: string;
  values?: object;
}

const FormattedMessageWrapper: React.FC<Props> = ({ langKey, values }) => {
  useTranslation([InternationalizationNameSpace.Legacy]);
  if (typeof langKey !== 'string' || langKey === '') {
    Logger.error('FormattedMessageWrapper error:', 'Faulty langKey passed to function:', langKey);
    return <span />;
  }
  const result = formatMessageWrapper(langKey, values);

  if (result === langKey || result === undefined) {
    return langKey;
  }

  return <span>{result}</span>;
};

export default FormattedMessageWrapper;
